<template>
    <el-menu
      :default-active="activeIndex"
      class="el-menu-vertical-demo"
      style="text-align: left"
      @open="handleOpen"
      @close="handleClose"
      :unique-opened="true"
      @select="selectFn"
      background-color="#fff"
      text-color="#000"
      active-text-color="#1c89f9"
      >
          <MenuTree  v-for="item in menuTree" :key="item.id" :menu="item"  />
    </el-menu>
<!--  background-color="#545c64"-->
<!--  text-color="#fff"-->
<!--  active-text-color="#ffd04b"-->
</template>

<script>
import MenuTree from '@/components/menu/MenuTree.vue'
import Bus from '@/api/Bus.js'
export default {
  data(){
    return {
      menuTree:[],
      activeIndex:'',
            // menuTree:[
            //     {   children: null,
            //         code: "SY",
            //         createId: "1088612450133330858",
            //         createTime: 1588130947000,
            //         description: " ",
            //         display: false,
            //         icon: "el-icon-message-solid",
            //         id: "10",
            //         modifyId: null,
            //         modifyTime: null,
            //         title:'首页',
            //         name: "首页",
            //         parentId: "0",
            //         quickPath: null,
            //         state: 0,
            //         type: "menu",
            //         urlPath: "index"
            //     },
            //     {   children: null,
            //         code: "XXGL",
            //         createId: "1088612450133330858",
            //         createTime: 1588130947000,
            //         description: " ",
            //         display: false,
            //         icon: "el-icon-message-solid",
            //         id: "20",
            //         modifyId: null,
            //         modifyTime: null,
            //         title:'线路管理',
            //         name: "线路管理",
            //         parentId: "0",
            //         quickPath: null,
            //         state: 0,
            //         type: "menu",
            //         urlPath: "lineManagement"
            //     },
            //     {
            //     children:[
            //       {
            //         children: null,
            //         code: "WDDD",
            //         createId: "1088612450133330858",
            //         createTime: 1588140260000,
            //         description: " ",
            //         display: false,
            //         icon: " ",
            //         id: "12565656418911",
            //         modifyId: null,
            //         modifyTime: null,
            //         name: "工程浏览",
            //         parentId: "30",
            //         quickPath: null,
            //         state: 0,
            //         type: "menu",
            //         urlPath: "engineering"
            //       },
            //       {
            //         children: null,
            //         code: "FPGL",
            //         createId: "1088612450133330858",
            //         createTime: 1588140286000,
            //         description: " ",
            //         display: false,
            //         icon: " ",
            //         id: "49365561354644",
            //         modifyId: null,
            //         modifyTime: null,
            //         name: "工程编辑",
            //         parentId: "30",
            //         quickPath: null,
            //         state: 0,
            //         type: "menu",
            //         urlPath: "editengineering"
            //       },
            //       {
            //         children: null,
            //         code: "FPGL",
            //         createId: "1088612450133330858",
            //         createTime: 1588140286000,
            //         description: " ",
            //         display: false,
            //         icon: " ",
            //         id: "84123216552323244",
            //         modifyId: null,
            //         modifyTime: null,
            //         name: "工程审核",
            //         parentId: "30",
            //         quickPath: null,
            //         state: 0,
            //         type: "menu",
            //         urlPath: "Trialengineering"
            //       },
            //       {
            //         children: null,
            //         code: "FPGL",
            //         createId: "108861245454545454",
            //         createTime: 1588140286000,
            //         description: " ",
            //         display: false,
            //         icon: " ",
            //         id: "4521215421545463232546",
            //         modifyId: null,
            //         modifyTime: null,
            //         name: "测量作业管理",
            //         parentId: "30",
            //         quickPath: null,
            //         state: 0,
            //         type: "menu",
            //         urlPath: "measurement"
            //       }
            //     ],
            //     code: "GCGL",
            //     createId: "1088612450133330858",
            //     createTime: 1588130812000,
            //     description: " ",
            //     display: false,
            //     icon: "el-icon-s-goods",
            //     id: "30",
            //     modifyId: null,
            //     modifyTime: null,
            //     name: "精测网测量工程管理",
            //     parentId: "0",
            //     quickPath: null,
            //     state: 0,
            //     type: "menu",
            //     urlPath: ""
            //   },
            //     {
            //         children:[
            //             {
            //                 children: null,
            //                 code: "WDDD",
            //                 createId: "1088612450133330858",
            //                 createTime: 1588140260000,
            //                 description: " ",
            //                 display: false,
            //                 icon: " ",
            //                 id: "1255377358416846849",
            //                 modifyId: null,
            //                 modifyTime: null,
            //                 name: "单位信息管理",
            //                 parentId: "40",
            //                 quickPath: null,
            //                 state: 0,
            //                 type: "menu",
            //                 urlPath: "basicManagement"
            //             },
            //             {
            //                 children: null,
            //                 code: "FPGL",
            //                 createId: "1088612450133330858",
            //                 createTime: 1588140286000,
            //                 description: " ",
            //                 display: false,
            //                 icon: " ",
            //                 id: "1255377465572925441",
            //                 modifyId: null,
            //                 modifyTime: null,
            //                 name: "人员信息管理",
            //                 parentId: "40",
            //                 quickPath: null,
            //                 state: 0,
            //                 type: "menu",
            //                 urlPath: "personInfor"
            //             },
            //             {
            //                 children: null,
            //                 code: "FPGL",
            //                 createId: "1088612450133330858",
            //                 createTime: 1588140286000,
            //                 description: " ",
            //                 display: false,
            //                 icon: " ",
            //                 id: "1255377666672925441",
            //                 modifyId: null,
            //                 modifyTime: null,
            //                 name: "设备信息管理",
            //                 parentId: "40",
            //                 quickPath: null,
            //                 state: 0,
            //                 type: "menu",
            //                 urlPath: "equipmentInfor"
            //             }
            //         ],
            //         code: "JCXX",
            //         createId: "1088612450133330858",
            //         createTime: 1588130812000,
            //         description: " ",
            //         display: false,
            //         icon: "el-icon-s-goods",
            //         id: "40",
            //         modifyId: null,
            //         modifyTime: null,
            //         name: "基础信息管理",
            //         parentId: "0",
            //         quickPath: null,
            //         state: 0,
            //         type: "menu",
            //         urlPath: ""
            //     },
            //     {
            //         children:[
            //             {
            //                 children: null,
            //                 code: "WDDD",
            //                 createId: "1088612450133330858",
            //                 createTime: 1588140260000,
            //                 description: " ",
            //                 display: false,
            //                 icon: "el-icon-message-solid",
            //                 id: "1255377344444446849",
            //                 modifyId: null,
            //                 modifyTime: null,
            //                 name: "控制点点位信息",
            //                 parentId: "50",
            //                 quickPath: null,
            //                 state: 0,
            //                 type: "menu",
            //                 urlPath: "controlPoint"
            //             },
            //         ],
            //         code: "JCSJ",
            //         createId: "1088612450133330858",
            //         createTime: 1588130812000,
            //         description: " ",
            //         display: false,
            //         icon: "el-icon-s-goods",
            //         id: "50",
            //         modifyId: null,
            //         modifyTime: null,
            //         name: "基础数据管理",
            //         parentId: "0",
            //         quickPath: null,
            //         state: 0,
            //         type: "menu",
            //         urlPath: ""
            //     },
            //     {
            //       children:[
            //         // {
            //         //   children: null,
            //         //   code: "GNCDWH",
            //         //   createId: "1088612450133330858",
            //         //   createTime: 1588140260000,
            //         //   description: " ",
            //         //   display: false,
            //         //   icon: " ",
            //         //   id: "6012565656418911",
            //         //   modifyId: null,
            //         //   modifyTime: null,
            //         //   name: "功能菜单维护",
            //         //   parentId: "30",
            //         //   quickPath: null,
            //         //   state: 0,
            //         //   type: "menu",
            //         //   urlPath: "department"
            //         // },
            //         {
            //           children: null,
            //           code: "XTYHGL",
            //           createId: "1088612450133330858",
            //           createTime: 1588140286000,
            //           description: " ",
            //           display: false,
            //           icon: " ",
            //           id: "6049365561354644",
            //           modifyId: null,
            //           modifyTime: null,
            //           name: "功能菜单维护",
            //           parentId: "30",
            //           quickPath: null,
            //           state: 0,
            //           type: "menu",
            //           urlPath: "Menu"
            //         },
            //         {
            //           children: null,
            //           code: "XTJSGL",
            //           createId: "1088612450133330858",
            //           createTime: 1588140286000,
            //           description: " ",
            //           display: false,
            //           icon: " ",
            //           id: "6084123216552323244",
            //           modifyId: null,
            //           modifyTime: null,
            //           name: "系统角色管理",
            //           parentId: "30",
            //           quickPath: null,
            //           state: 0,
            //           type: "menu",
            //           urlPath: "role"
            //         },
            //         {
            //           children: null,
            //           code: "JSQXGL",
            //           createId: "108861245454545454",
            //           createTime: 1588140286000,
            //           description: " ",
            //           display: false,
            //           icon: " ",
            //           id: "604521215421545463232546",
            //           modifyId: null,
            //           modifyTime: null,
            //           name: "角色权限管理",
            //           parentId: "30",
            //           quickPath: null,
            //           state: 0,
            //           type: "menu",
            //           urlPath: "roleFunction"
            //         },
            //         {
            //           children: null,
            //           code: "XTJSGL",
            //           createId: "1088612450133330858",
            //           createTime: 1588140286000,
            //           description: " ",
            //           display: false,
            //           icon: " ",
            //           id: "60184123216552323244",
            //           modifyId: null,
            //           modifyTime: null,
            //           name: "系统角色管理",
            //           parentId: "30",
            //           quickPath: null,
            //           state: 0,
            //           type: "menu",
            //           urlPath: "SystemConfig"
            //         },
            //         // {
            //         //   children: null,
            //         //   code: "JSQXGL",
            //         //   createId: "108861245454545454",
            //         //   createTime: 1588140286000,
            //         //   description: " ",
            //         //   display: false,
            //         //   icon: " ",
            //         //   id: "6024521215421545463232546",
            //         //   modifyId: null,
            //         //   modifyTime: null,
            //         //   name: "角色权限管理",
            //         //   parentId: "30",
            //         //   quickPath: null,
            //         //   state: 0,
            //         //   type: "menu",
            //         //   urlPath: "Tenant"
            //         // },
            //         // {
            //         //   children: null,
            //         //   code: "XTJSGL",
            //         //   createId: "1088612450133330858",
            //         //   createTime: 1588140286000,
            //         //   description: " ",
            //         //   display: false,
            //         //   icon: " ",
            //         //   id: "60384123216552323244",
            //         //   modifyId: null,
            //         //   modifyTime: null,
            //         //   name: "系统角色管理",
            //         //   parentId: "30",
            //         //   quickPath: null,
            //         //   state: 0,
            //         //   type: "menu",
            //         //   urlPath: "user"
            //         // },
            //         // {
            //         //   children: null,
            //         //   code: "JSQXGL",
            //         //   createId: "108861245454545454",
            //         //   createTime: 1588140286000,
            //         //   description: " ",
            //         //   display: false,
            //         //   icon: " ",
            //         //   id: "604521215421545463232546",
            //         //   modifyId: null,
            //         //   modifyTime: null,
            //         //   name: "角色权限管理",
            //         //   parentId: "30",
            //         //   quickPath: null,
            //         //   state: 0,
            //         //   type: "menu",
            //         //   urlPath: "UserRoles"
            //         // },
            //         // {
            //         //   children: null,
            //         //   code: "XTJSGL",
            //         //   createId: "1088612450133330858",
            //         //   createTime: 1588140286000,
            //         //   description: " ",
            //         //   display: false,
            //         //   icon: " ",
            //         //   id: "60584123216552323244",
            //         //   modifyId: null,
            //         //   modifyTime: null,
            //         //   name: "系统角色管理",
            //         //   parentId: "30",
            //         //   quickPath: null,
            //         //   state: 0,
            //         //   type: "menu",
            //         //   urlPath: "operation"
            //         // }
            //       ],
            //       code: "XTSZ",
            //       createId: "1088612450133330858",
            //       createTime: 1588130812000,
            //       description: " ",
            //       display: false,
            //       icon: "el-icon-s-goods",
            //       id: "60",
            //       modifyId: null,
            //       modifyTime: null,
            //       name: "系统设置",
            //       parentId: "0",
            //       quickPath: null,
            //       state: 0,
            //       type: "menu",
            //       urlPath: ""
            //     },
            //
            //
            // ]
    }
  },
  components:{
    MenuTree
  },
  computed: {
    // activeIndex () {
    //
    //   //console.log(this.$route)
    //   //return this.$route.path.replace('/', '')
    // }
  },
  methods:{
      handleOpen(key, keyPath){
        //console.log(key, keyPath);
      },
      handleClose(key, keyPath){
        //console.log(key, keyPath);
      },
    getMenuTree (menuList =[]){

      menuList.forEach((item,index,arr) =>　{
        item['url'] = item.url
        item['title'] = item.name

        if(item.children){
          this.getMenuTree(item.children)
        }
      })
    },
    selectFn(index,indexPath){
        //console.log(Index,'Index',indexPath,'indexpath')
      this.activeIndex=index
    }

  },
  created () {
    this.menuTree = this.$store.state.user.role
    this.getMenuTree(this.menuTree)

  },
  mounted() {
    Bus.$on('watchrole', (w) => {
      this.menuTree = this.$store.state.user.role
      this.getMenuTree(this.menuTree)
    })
  },
  destroyed() {
    this.menuTree=[]
  }
}
</script>


<style lang="less" scoped>
.el-menu-vertical-demo{
  overflow: hidden;

}
</style>



// WEBPACK FOOTER //
// src/components/home-left/home-left.vue